import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import KeypopulationtypeFormData from "./KeypopulationtypeFormData"
import encryptionService from "../../../services/encryptionService";


function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const EditKeypopulationtype = (props) => {

  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "key-population-type-entry";
const UserInfo = encryptionService.decryptUserInfo();  
const UserName = UserInfo==0?'': UserInfo[0].name;


  const [formData, setFormData] = useState({
    KeypopulationType: "",
    KeypopulationTypeFull: ""
  });
  
  
  
  
  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

   const { data } = useQuery(
    ["ordertype", id],
    () =>
      api.getKeypopulationtypeSingle(id).then((res) => {
        setFormData(res.data);
        return res.data;
      }),
    {
      enabled: Boolean(id),
    }
  ); 

  const { isLoading, mutate } = useMutation(api.updateKeypopulationtype, {
    onSuccess: (data) => {
      if (data.status == 200) {

        api.getAllDropdown('KeypopulationType').then((response) => {
          localStorage.setItem(
            "KeypopulationType",
            JSON.stringify(response.datalist.KeypopulationType)
          );
        })
       
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });

        queryClient.getQueriesData("ordertype");// include the page name
        props.history.push("/key-population-type-entry");//page url
        
        
        }else{   
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        }
    },
  });

 

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;

    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      KeypopulationType: "",
      KeypopulationTypeFull: ""
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["KeypopulationType","KeypopulationTypeFull"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = DispensingLanguage[lan][menukey]['field is Required !'];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };


  const handleUpdate = async (e) => {
    if (validateForm(formData)) {
      let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName}; 
      mutate(fDtat);
      //mutate(formData);
     
      
    }
  };

  return (
    <>
      <KeypopulationtypeFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        {...props}
      />
    </>
  );
};

export default EditKeypopulationtype;
